<div (window:resize)="readjustSize()" class="screen-element screen-menu">
	
	<div #titleElement [ngStyle]="{'opacity':titleopacity}" class="text title" [ngClass]="{'darkTitle':hasParameter('darkTitle'),'darkerTitle':hasParameter('darkerTitle')}">{{title|uppercase}}<span *ngIf="menuIcon" class="menu-icon inline-icon {{menuIcon}}">&nbsp;</span></div>
	<div #titleElement2 [ngStyle]="{'opacity':titleopacity}" class="text subtitle">{{subtitle}}</div>
	<div class="marker"></div>

	<div #wrapElement 
	[ngStyle]="{'top':top}"
	[ngClass]="{'transition-enabled': transitionalMovement() }"
	class="menu-elements-wrap"
	>
	<div *ngFor="let el of menuElements">
		<div class="menu-row-wrap">

			<div class="menu-row" [ngClass]="{'active':el==currentElement,'nobox':hasParameter('nobox')}">
				
					<div class="menu-item-wrap">
						<div class="menu-item">
							<!--
								<span *ngIf="el.icon" class="icon inline-icon {{el.icon}}"></span>
								<span class="">{{el.getTitle()}}</span>
							-->
							<text-widget [color]="getColor(el)" [text]="el.getTitle()"></text-widget>
						</div>
					</div>
			
			</div>
		</div>
		<div class="submenu-wrap" [ngClass]="{'open':isOpen(el)}">
			<div *ngFor="let subEl of el.getChilds()" class="submenu-row"  [ngClass]="{'active':subEl==currentElement}">
				<div class="menu-item-wrap">
					<div class="menu-item">
						<span>{{subEl.getTitle()}}</span>
					</div>
				</div>
			</div>
		</div>
	</div>

	</div>
</div>